enum Services {
  LIVE = 'Live',
  MULTISCREEN = 'Multipantalla',
  RECORDINGS = 'Grabaciones',
  RECORDINGS_FREE = 'Grabaciones Free',
  RESTART = 'RestartLive',
  RESTART_FREE = 'RestartLive Free',
  TIMESHIFT = 'Timeshift',
  YOU_MISSED_IT = 'TeLoPerdiste',
  YOU_MISSED_IT_FREE = 'TeLoPerdiste Free',
}

export default Services;
